// export const apiUrl = "http://101.187.98.39:8181/online_report_api/public/api";
// export const apiUrl = "http://localhost:8002/api";
// export const apiUrl = "http://121.211.190.104:8181/online_report_api/public/api";
// export const apiUrl = "http://localhost:8000/api";
// export const apiUrl = "http://208.68.39.35/api";
// export const apiUrl = "http://192.168.20.103/api";
export const apiUrl = "https://onlinereport-api.redpayments.com.au/api";
